import { InnerContentItem } from "@certn/cascadia-react";
import { components } from "@certn/legacy-api/generated-schemas/people";
import { Trans } from "react-i18next";

const sexes = {
  M: <Trans>Male</Trans>,
  F: <Trans>Female</Trans>,
  X: <Trans>X</Trans>,
  "": "-",
};

export function SexSummaryField({
  field,
}: {
  field: components["schemas"]["SexCheckField"];
}) {
  return (
    <InnerContentItem testID="sex-summary">
      {sexes[field.value]}
    </InnerContentItem>
  );
}
